import { Injectable, inject } from '@angular/core';
import { User } from '@models/user';
import { LocalStorageService } from './local-storage.service';

/**
 * service to provide format locale
 * used by date, number and currency pipes
 */
@Injectable( {
    providedIn: 'root'
} )
export class LocaleService {
    /** reference on current locale */
    static locale: string;
    locale: string | undefined;

    /**
     * reference on user account,
     * which holds preferred formatLocale in settings
     */
    #account!: User;

    #localStorageService = inject( LocalStorageService );

    constructor() {
        this.locale = this.getLocale();
    }

    /**
     * get current format locale
     * if user is logged in
     * account holds preferred format locale
     * otherwise the language attribute from browser is taken
     *
     * browser language could be either:
     * - the default browser language, or
     * - the language choosen by language switch, -> stored as cookie
     * @returns {string} locale
     */
    getLocale() {
        this.#account = this.#localStorageService.load( 'account' );
        return this.#account ? this.#account.formatLocale : document.documentElement.lang;
    }

    /**
     * convenient function to set locale
     * when user changes locale in profile settings
     * @param {string} lang - language code
     */
    setLocale( lang = 'en' ): void {
        this.locale = lang;
        this.windowReload()
    }

    /** helper function to reload window */
    windowReload(): void {
        window.location.reload();
    }
}
